import React, { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { useNavigate } from "react-router";
import { NavigationDatenschutz } from "../components/navigationdatenschutz";
import { Footer } from "../components/footer";
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Datenschutz = () => {
  //https://react-landing-page-template-93ne.vercel.app/
  //https://github.com/issaafalkattan/React-Landing-Page-Template
  const navigate = useNavigate();

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <NavigationDatenschutz />
      <div>
        <br />
      </div>
      <div id="datenschutz">
        <div className="container">
          <section>
            <div className="container">
              <div className="section-title">
                <h2>Datenschutz</h2>
              </div>
              <div id="row">
                <p>
                  Personenbezogene Daten (nachfolgend zumeist nur „Daten“
                  genannt) werden von uns nur im Rahmen der Erforderlichkeit
                  sowie zum Zwecke der Bereitstellung eines funktionsfähigen und
                  nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte
                  und der dort angebotenen Leistungen, verarbeitet.
                </p>
                <p>
                  Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der
                  Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt),
                  gilt als „Verarbeitung“ jeder mit oder ohne Hilfe
                  automatisierter Verfahren ausgeführter Vorgang oder jede
                  solche Vorgangsreihe im Zusammenhang mit personenbezogenen
                  Daten, wie das Erheben, das Erfassen, die Organisation, das
                  Ordnen, die Speicherung, die Anpassung oder Veränderung, das
                  Auslesen, das Abfragen, die Verwendung, die Offenlegung durch
                  Übermittlung, Verbreitung oder eine andere Form der
                  Bereitstellung, den Abgleich oder die Verknüpfung, die
                  Einschränkung, das Löschen oder die Vernichtung.
                </p>
                <p>
                  Mit der nachfolgenden Datenschutzerklärung informieren wir Sie
                  insbesondere über Art, Umfang, Zweck, Dauer und
                  Rechtsgrundlage der Verarbeitung personenbezogener Daten,
                  soweit wir entweder allein oder gemeinsam mit anderen über die
                  Zwecke und Mittel der Verarbeitung entscheiden. Zudem
                  informieren wir Sie nachfolgend über die von uns zu
                  Optimierungszwecken sowie zur Steigerung der Nutzungsqualität
                  eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten
                  in wiederum eigener Verantwortung verarbeiten.
                </p>
                <p>Unsere Datenschutzerklärung ist wie folgt gegliedert:</p>
                <p>
                  I. Informationen über uns als Verantwortliche
                  <br />
                  II. Rechte der Nutzer und Betroffenen
                  <br />
                  III. Informationen zur Datenverarbeitung
                </p>
                <h3>I. Informationen über uns als Verantwortliche</h3>
                <p>
                  Verantwortlicher Anbieter dieses Internetauftritts im
                  datenschutzrechtlichen Sinne ist:
                </p>
                {landingPageData.Contact ? landingPageData.Contact.ceo: "Lädt..."}
                <br />
                {landingPageData.Contact ? landingPageData.Contact.street: "Lädt..."}
                <br />
                {landingPageData.Contact ? landingPageData.Contact.zipcode: "Lädt..."}, {landingPageData.Contact ? landingPageData.Contact.city: "Lädt..."}{" "}
                <p>
                  Telefon: {landingPageData.Contact ? landingPageData.Contact.phone: "Lädt..."}
                 { 
                 // <br />
                 // Telefax: [Faxnummer]
                 }
                 <br />
                  E-Mail: {landingPageData.Contact ? landingPageData.Contact.email: "Lädt..."}{" "}
                </p>
                <h3>II. Rechte der Nutzer und Betroffenen</h3>
                <p>
                  Mit Blick auf die nachfolgend noch näher beschriebene
                  Datenverarbeitung haben die Nutzer und Betroffenen das Recht
                </p>
                <ul>
                  <li>
                    auf Bestätigung, ob sie betreffende Daten verarbeitet
                    werden, auf Auskunft über die verarbeiteten Daten, auf
                    weitere Informationen über die Datenverarbeitung sowie auf
                    Kopien der Daten (vgl. auch Art. 15 DSGVO);
                  </li>
                  <li>
                    auf Berichtigung oder Vervollständigung unrichtiger bzw.
                    unvollständiger Daten (vgl. auch Art. 16 DSGVO);
                  </li>
                  <li>
                    auf unverzügliche Löschung der sie betreffenden Daten (vgl.
                    auch Art. 17 DSGVO), oder, alternativ, soweit eine weitere
                    Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist,
                    auf Einschränkung der Verarbeitung nach Maßgabe von Art. 18
                    DSGVO;
                  </li>
                  <li>
                    auf Erhalt der sie betreffenden und von ihnen
                    bereitgestellten Daten und auf Übermittlung dieser Daten an
                    andere Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);
                  </li>
                  <li>
                    auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie
                    der Ansicht sind, dass die sie betreffenden Daten durch den
                    Anbieter unter Verstoß gegen datenschutzrechtliche
                    Bestimmungen verarbeitet werden (vgl. auch Art. 77 DSGVO).
                  </li>
                </ul>
                <p>
                  Darüber hinaus ist der Anbieter dazu verpflichtet, alle
                  Empfänger, denen gegenüber Daten durch den Anbieter
                  offengelegt worden sind, über jedwede Berichtigung oder
                  Löschung von Daten oder die Einschränkung der Verarbeitung,
                  die aufgrund der Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu
                  unterrichten. Diese Verpflichtung besteht jedoch nicht, soweit
                  diese Mitteilung unmöglich oder mit einem unverhältnismäßigen
                  Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein
                  Recht auf Auskunft über diese Empfänger.
                </p>
                <p>
                  <strong>
                    Ebenfalls haben die Nutzer und Betroffenen nach Art. 21
                    DSGVO das Recht auf Widerspruch gegen die künftige
                    Verarbeitung der sie betreffenden Daten, sofern die Daten
                    durch den Anbieter nach Maßgabe von Art. 6 Abs. 1 lit. f)
                    DSGVO verarbeitet werden. Insbesondere ist ein Widerspruch
                    gegen die Datenverarbeitung zum Zwecke der Direktwerbung
                    statthaft.
                  </strong>
                </p>
                <h3>III. Informationen zur Datenverarbeitung</h3>
                <p>
                  Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten
                  werden gelöscht oder gesperrt, sobald der Zweck der
                  Speicherung entfällt, der Löschung der Daten keine
                  gesetzlichen Aufbewahrungspflichten entgegenstehen und
                  nachfolgend keine anderslautenden Angaben zu einzelnen
                  Verarbeitungsverfahren gemacht werden.
                </p>
                <h4 class="jet-listing-dynamic-field__content">
                  Kontaktanfragen / Kontaktmöglichkeit
                </h4>
                <p>
                  Sofern Sie per Kontaktformular oder E-Mail mit uns in Kontakt
                  treten, werden die dabei von Ihnen angegebenen Daten zur
                  Bearbeitung Ihrer Anfrage genutzt. Die Angabe der Daten ist
                  zur Bearbeitung und Beantwortung Ihre Anfrage erforderlich –
                  ohne deren Bereitstellung können wir Ihre Anfrage nicht oder
                  allenfalls eingeschränkt beantworten.
                </p>
                <p>
                  Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit.
                  b) DSGVO.
                </p>
                <p>
                  Ihre Daten werden gelöscht, sofern Ihre Anfrage abschließend
                  beantwortet worden ist und der Löschung keine gesetzlichen
                  Aufbewahrungspflichten entgegenstehen, wie bspw. bei einer
                  sich etwaig anschließenden Vertragsabwicklung.
                </p>
                <h4 class="jet-listing-dynamic-field__content">LinkedIn</h4>
                <p>
                  Wir unterhalten bei LinkedIn eine Onlinepräsenz um unser
                  Unternehmen sowie unsere Leistungen zu präsentieren und mit
                  Kunden/Interessenten zu kommunizieren. LinkedIn ist ein
                  Service der LinkedIn Ireland Unlimited Company, Wilton Plaza,
                  Wilton Place, Dublin 2, Irland, ein Tochterunternehmen der
                  LinkedIn Corporation, 1000 W. Maude Avenue, Sunnyvale, CA
                  94085, USA.
                </p>
                <p>
                  Insofern weisen wir darauf hin, dass die Möglichkeit besteht,
                  dass Daten der Nutzer außerhalb der Europäischen Union,
                  insbesondere in den USA, verarbeitet werden. Hierdurch können
                  gesteigerte Risiken für die Nutzer insofern bestehen, als dass
                  z.B. der spätere Zugriff auf die Nutzerdaten erschwert werden
                  kann. Auch haben wir keinen Zugriff auf diese Nutzerdaten. Die
                  Zugriffsmöglichkeit liegt ausschließlich bei LinkedIn.
                </p>
                <p>Die Datenschutzhinweise von LinkedIn finden Sie unter</p>
                <p>
                  <a
                    href="https://www.linkedin.com/legal/privacy-policy"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.linkedin.com/legal/privacy-policy
                  </a>
                </p>
                <h4 class="jet-listing-dynamic-field__content">Facebook</h4>
                <p>
                  Zur Bewerbung unserer Produkte und Leistungen sowie zur
                  Kommunikation mit Interessenten oder Kunden betreiben wir eine
                  Firmenpräsenz auf der Plattform Facebook.
                </p>
                <p>
                  Auf dieser Social-Media-Plattform sind wir gemeinsam mit der
                  Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal
                  Harbour, Dublin 2 Ireland, verantwortlich.
                </p>
                <p>
                  Der Datenschutzbeauftragte von Facebook kann über ein
                  Kontaktformular erreicht werden:
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/help/contact/540977946302970"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/help/contact/540977946302970
                  </a>
                </p>
                <p>
                  Die gemeinsame Verantwortlichkeit haben wir in einer
                  Vereinbarung bezüglich der jeweiligen Verpflichtungen im Sinne
                  der DSGVO geregelt. Diese Vereinbarung, aus der sich die
                  gegenseitigen Verpflichtungen ergeben, ist unter dem folgenden
                  Link abrufbar:
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/legal/terms/page_controller_addendum"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/legal/terms/page_controller_addendum
                  </a>
                </p>
                <p>
                  Rechtsgrundlage für die dadurch erfolgende und nachfolgend
                  wiedergegebene Verarbeitung von personenbezogenen Daten ist
                  Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse
                  besteht an der Analyse, der Kommunikation sowie dem Absatz und
                  der Bewerbung unserer Produkte und Leistungen.
                </p>
                <p>
                  Rechtsgrundlage kann auch eine Einwilligung des Nutzers gemäß
                  Art. 6 Abs. 1 lit. a DSGVO gegenüber dem Plattformbetreiber
                  sein. Die Einwilligung hierzu kann der Nutzer nach Art. 7 Abs.
                  3 DSGVO jederzeit durch eine Mitteilung an den
                  Plattformbetreiber für die Zukunft widerrufen.
                </p>
                <p>
                  Bei dem Aufruf unseres Onlineauftritts auf der Plattform
                  Facebook werden von der Facebook Ireland Ltd. als Betreiberin
                  der Plattform in der EU Daten des Nutzers (z.B. persönliche
                  Informationen, IP-Adresse etc.) verarbeitet.
                </p>
                <p>
                  Diese Daten des Nutzers dienen zu statistischen Informationen
                  über die Inanspruchnahme unserer Firmenpräsenz auf Facebook.
                  Die Facebook Ireland Ltd. nutzt diese Daten zu
                  Marktforschungs- und Werbezwecken sowie zur Erstellung von
                  Profilen der Nutzer. Anhand dieser Profile ist es der Facebook
                  Ireland Ltd. beispielsweise möglich, die Nutzer innerhalb und
                  außerhalb von Facebook interessenbezogen zu bewerben. Ist der
                  Nutzer zum Zeitpunkt des Aufrufes in seinem Account auf
                  Facebook eingeloggt, kann die Facebook Ireland Ltd. zudem die
                  Daten mit dem jeweiligen Nutzerkonto verknüpfen.
                </p>
                <p>
                  Im Falle einer Kontaktaufnahme des Nutzers über Facebook
                  werden die bei dieser Gelegenheit eingegebenen
                  personenbezogenen Daten des Nutzers zur Bearbeitung der
                  Anfrage genutzt. Die Daten des Nutzers werden bei uns
                  gelöscht, sofern die Anfrage des Nutzers abschließend
                  beantwortet wurde und keine gesetzlichen
                  Aufbewahrungspflichten, wie z.B. bei einer anschließenden
                  Vertragsabwicklung, entgegenstehen.
                </p>
                <p>
                  Zur Verarbeitung der Daten werden von der Facebook Ireland
                  Ltd. ggf. auch Cookies gesetzt.
                </p>
                <p>
                  Sollte der Nutzer mit dieser Verarbeitung nicht einverstanden
                  sein, so besteht die Möglichkeit, die Installation der Cookies
                  durch eine entsprechende Einstellung des Browsers zu
                  verhindern. Bereits gespeicherte Cookies können ebenfalls
                  jederzeit gelöscht werden. Die Einstellungen hierzu sind vom
                  jeweiligen Browser abhängig. Bei Flash-Cookies lässt sich die
                  Verarbeitung nicht über die Einstellungen des Browsers
                  unterbinden, sondern durch die entsprechende Einstellung des
                  Flash-Players. Sollte der Nutzer die Installation der Cookies
                  verhindern oder einschränken, kann dies dazu führen, dass
                  nicht sämtliche Funktionen von Facebook vollumfänglich nutzbar
                  sind.
                </p>
                <p>
                  Näheres zu den Verarbeitungstätigkeiten, deren Unterbindung
                  und zur Löschung der von Facebook verarbeiteten Daten finden
                  sich in der Datenrichtlinie von Facebook:
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/privacy/explanation"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/privacy/explanation
                  </a>
                </p>
                <p>
                  Es ist nicht ausgeschlossen, dass die Verarbeitung durch die
                  Facebook Ireland Ltd. auch über die Facebook Inc., 1601 Willow
                  Road, Menlo Park, California 94025 in den USA erfolgt.
                </p>
                <h4 class="jet-listing-dynamic-field__content">Instagram</h4>
                <p>
                  Zur Bewerbung unserer Produkte und Leistungen sowie zur
                  Kommunikation mit Interessenten oder Kunden betreiben wir eine
                  Firmenpräsenz auf der Plattform Instagram.
                </p>
                <p>
                  Auf dieser Social-Media-Plattform sind wir gemeinsam mit der
                  Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal
                  Harbour, Dublin 2 Ireland, verantwortlich.
                </p>
                <p>
                  Der Datenschutzbeauftragte von Instagram kann über ein
                  Kontaktformular erreicht werden:
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/help/contact/540977946302970"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/help/contact/540977946302970
                  </a>
                </p>
                <p>
                  Die gemeinsame Verantwortlichkeit haben wir in einer
                  Vereinbarung bezüglich der jeweiligen Verpflichtungen im Sinne
                  der DSGVO geregelt. Diese Vereinbarung, aus der sich die
                  gegenseitigen Verpflichtungen ergeben, ist unter dem folgenden
                  Link abrufbar:
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/legal/terms/page_controller_addendum"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/legal/terms/page_controller_addendum
                  </a>
                </p>
                <p>
                  Rechtsgrundlage für die dadurch erfolgende und nachfolgend
                  wiedergegebene Verarbeitung von personenbezogenen Daten ist
                  Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse
                  besteht an der Analyse, der Kommunikation sowie dem Absatz und
                  der Bewerbung unserer Produkte und Leistungen.
                </p>
                <p>
                  Rechtsgrundlage kann auch eine Einwilligung des Nutzers gemäß
                  Art. 6 Abs. 1 lit. a DSGVO gegenüber dem Plattformbetreiber
                  sein. Die Einwilligung hierzu kann der Nutzer nach Art. 7 Abs.
                  3 DSGVO jederzeit durch eine Mitteilung an den
                  Plattformbetreiber für die Zukunft widerrufen.
                </p>
                <p>
                  Bei dem Aufruf unseres Onlineauftritts auf der Plattform
                  Instagram werden von der Facebook Ireland Ltd. als Betreiberin
                  der Plattform in der EU Daten des Nutzers (z.B. persönliche
                  Informationen, IP-Adresse etc.) verarbeitet.
                </p>
                <p>
                  Diese Daten des Nutzers dienen zu statistischen Informationen
                  über die Inanspruchnahme unserer Firmenpräsenz auf Instagram.
                  Die Facebook Ireland Ltd. nutzt diese Daten zu
                  Marktforschungs- und Werbezwecken sowie zur Erstellung von
                  Profilen der Nutzer. Anhand dieser Profile ist es der Facebook
                  Ireland Ltd. beispielsweise möglich, die Nutzer innerhalb und
                  außerhalb von Instagram interessenbezogen zu bewerben. Ist der
                  Nutzer zum Zeitpunkt des Aufrufes in seinem Account auf
                  Instagram eingeloggt, kann die Facebook Ireland Ltd. zudem die
                  Daten mit dem jeweiligen Nutzerkonto verknüpfen.
                </p>
                <p>
                  Im Falle einer Kontaktaufnahme des Nutzers über Instagram
                  werden die bei dieser Gelegenheit eingegebenen
                  personenbezogenen Daten des Nutzers zur Bearbeitung der
                  Anfrage genutzt. Die Daten des Nutzers werden bei uns
                  gelöscht, sofern die Anfrage des Nutzers abschließend
                  beantwortet wurde und keine gesetzlichen
                  Aufbewahrungspflichten, wie z.B. bei einer anschließenden
                  Vertragsabwicklung, entgegenstehen.
                </p>
                <p>
                  Zur Verarbeitung der Daten werden von der Facebook Ireland
                  Ltd. ggf. auch Cookies gesetzt.
                </p>
                <p>
                  Sollte der Nutzer mit dieser Verarbeitung nicht einverstanden
                  sein, so besteht die Möglichkeit, die Installation der Cookies
                  durch eine entsprechende Einstellung des Browsers zu
                  verhindern. Bereits gespeicherte Cookies können ebenfalls
                  jederzeit gelöscht werden. Die Einstellungen hierzu sind vom
                  jeweiligen Browser abhängig. Bei Flash-Cookies lässt sich die
                  Verarbeitung nicht über die Einstellungen des Browsers
                  unterbinden, sondern durch die entsprechende Einstellung des
                  Flash-Players. Sollte der Nutzer die Installation der Cookies
                  verhindern oder einschränken, kann dies dazu führen, dass
                  nicht sämtliche Funktionen von Facebook vollumfänglich nutzbar
                  sind.
                </p>
                <p>
                  Näheres zu den Verarbeitungstätigkeiten, deren Unterbindung
                  und zur Löschung der von Instagram verarbeiteten Daten finden
                  sich in der Datenrichtlinie von Instagram:
                </p>
                <p>
                  <a
                    href="https://help.instagram.com/519522125107875"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://help.instagram.com/519522125107875
                  </a>
                </p>
                <p>
                  Es ist nicht ausgeschlossen, dass die Verarbeitung durch die
                  Facebook Ireland Ltd. auch über die Facebook Inc., 1601 Willow
                  Road, Menlo Park, California 94025 in den USA erfolgt.
                </p>
                <h4 class="jet-listing-dynamic-field__content">facebook</h4>
                <p>
                  Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2,
                  Ireland, ein Tochterunternehmen der Facebook Inc., 1601 S.
                  California Ave., Palo Alto, CA 94304, USA.
                </p>
                <p>
                  Datenschutzerklärung:{" "}
                  <a
                    href="https://www.facebook.com/policy.php"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.facebook.com/policy.php
                  </a>
                </p>
                <h4 class="jet-listing-dynamic-field__content">LinkedIn</h4>
                <p>
                  LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton
                  Place, Dublin 2, Irland, ein Tochterunternehmen der LinkedIn
                  Corporation, 1000 W. Maude Avenue, Sunnyvale, CA 94085 USA.
                </p>
                <p>
                  Datenschutzerklärung:{" "}
                  <a
                    href="https://www.linkedin.com/legal/privacy-policy"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.linkedin.com/legal/privacy-policy
                  </a>
                </p>
                <h4 class="jet-listing-dynamic-field__content">Instagram</h4>
                <p>
                  Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2,
                  Ireland, ein Tochterunternehmen der Facebook Inc., 1601 S.
                  California Ave., Palo Alto, CA 94304, USA.
                </p>
                <p>
                  Datenschutzerklärung:{" "}
                  <a
                    href="https://help.instagram.com/519522125107875"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://help.instagram.com/519522125107875
                  </a>
                </p>
                <h4 class="jet-listing-dynamic-field__content">Google Fonts</h4>
                <p>
                  In unserem Internetauftritt setzen wir Google Fonts zur
                  Darstellung externer Schriftarten ein. Es handelt sich hierbei
                  um einen Dienst der Google Ireland Limited, Gordon House,
                  Barrow Street, Dublin 4, Irland, nachfolgend nur „Google“
                  genannt.
                </p>
                <p>
                  Um die Darstellung bestimmter Schriften in unserem
                  Internetauftritt zu ermöglichen, wird bei Aufruf unseres
                  Internetauftritts eine Verbindung zu dem Google-Server in den
                  USA aufgebaut.
                </p>
                <p>
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser
                  berechtigtes Interesse liegt in der Optimierung und dem
                  wirtschaftlichen Betrieb unseres Internetauftritts.
                </p>
                <p>
                  Durch die bei Aufruf unseres Internetauftritts hergestellte
                  Verbindung zu Google kann Google ermitteln, von welcher
                  Website Ihre Anfrage gesendet worden ist und an welche
                  IP-Adresse die Darstellung der Schrift zu übermitteln ist.
                </p>
                <p>Google bietet unter</p>
                <p>
                  <a
                    href="https://adssettings.google.com/authenticated"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://adssettings.google.com/authenticated
                  </a>
                </p>
                <p>
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://policies.google.com/privacy
                  </a>
                </p>
                <p>
                  weitere Informationen an und zwar insbesondere zu den
                  Möglichkeiten der Unterbindung der Datennutzung.
                </p>
                <h4 class="jet-listing-dynamic-field__content">FontAwesome</h4>
                <p>
                  Um Schriften und visuelle Elemente unseres Internetauftritts
                  darstellen zu können, setzen wir die externen Schriftarten von
                  FontAwesome ein. Bei FontAwesome handelt es sich um einen
                  Dienst der
                </p>
                <p>
                  Fonticons Inc., 6 Porter Road, Apartment 3R, Cambridge, MA
                  02140, USA, nachfolgend nur „FontAwesome“ genannt.
                </p>
                <p>
                  Bei dem Aufruf unseres Internetauftritts wird eine Verbindung
                  zum Server von FontAwesome in den USA aufgebaut, um so die
                  Darstellung von Schriften und visuellen Elemente zu
                  ermöglichen und zu aktualisieren.
                </p>
                <p>
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser
                  berechtigtes Interesse liegt in der Optimierung und dem
                  wirtschaftlichen Betrieb unseres Internetauftritts.
                </p>
                <p>
                  Durch die bei Aufruf unseres Internetauftritts hergestellte
                  Verbindung zum Server von FontAwesome kann FontAwesome
                  ermitteln, von welcher Website Ihre Anfrage gesendet worden
                  ist und an welche IP-Adresse die Darstellung der Schrift zu
                  übermitteln ist.
                </p>
                <p>FontAwesome bietet unter</p>
                <p>
                  <a
                    href="https://fontawesome.com/privacy"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://fontawesome.com/privacy
                  </a>
                </p>
                <p>
                  weitere Informationen an und zwar insbesondere zu den
                  Möglichkeiten der Unterbindung der Datennutzung.
                </p>
                <h4 class="jet-listing-dynamic-field__content">BootstrapCDN</h4>
                <p>
                  Zur Optimierung der Abrufgeschwindigkeit, der Gestaltung und
                  Darstellung der Inhalte unseres Internetauftritts auf
                  unterschiedlichen Endgeräten setzen wir in unserem
                  Internetauftritt den Dienst BootstrapCDN, ein Content Delivery
                  Network („CDN“), ein. Hierbei handelt es sich um einen Dienst
                  der StackPath, LLC, 2021 McKinney Ave. Suite 1100, Dallas, TX
                  75201, USA, nachfolgend nur „BootstrapCDN“ genannt.
                </p>
                <p>
                  Um die Inhalte unseres Internetauftritts schnell ausliefern zu
                  können, greift der Dienst auf sog. JavaScript-Bibliotheken
                  zurück. Dabei werden entsprechende Dateien von einem Server
                  von BootstrapCDN geladen, der Ihre IP-Adresse erfasst.
                </p>
                <p>Zudem bietet BootstrapCDN unter</p>
                <p>
                  <a
                    href="https://www.stackpath.com/legal/master-service-agreement/#privacy"
                    target="_blank"
                    rel="noopener nofollow"
                  >
                    https://www.stackpath.com/legal/master-service-agreement/#privacy
                  </a>{" "}
                  &nbsp;&nbsp;
                </p>
                <p>weitergehende Datenschutzinformationen an.</p>
                <p>
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser
                  berechtigtes Interesse liegt in der Beschleunigung der
                  Ladezeiten unseres Internetauftritts sowie in dessen
                  Optimierung.
                </p>
                <p>
                  Um die Ausführung des Java-Script-Codes von BootstrapCDN
                  insgesamt zu verhindern, können Sie einen sog.
                  Java-Script-Blocker installieren, wie bspw. noscript.net oder
                  ghostery.com. Sollten Sie die Ausführung des Java-Script-Codes
                  verhindern oder einschränken, kann dies aus technischen
                  Gründen allerdings dazu führen, dass womöglich nicht sämtliche
                  Inhalte und Funktionen unseres Internetauftritts verfügbar
                  sind.
                </p>
                <h4 class="jet-listing-dynamic-field__content">jQuery CDN</h4>
                <p>
                  Zur Optimierung der Abrufgeschwindigkeit, der Gestaltung und
                  Darstellung der Inhalte unseres Internetauftritts auf
                  unterschiedlichen Endgeräten setzen wir in unserem
                  Internetauftritt den Dienst
                </p>
                <p>
                  jQuery CDN, ein Content Delivery Network („CDN“), ein. Hierbei
                  handelt es sich um einen Dienst der jQuery Foundation,
                  nachfolgend nur „jQuery“ genannt. jQuery wird für die JS
                  Foundation über das StackPath CDN verteilt.
                </p>
                <p>
                  Um die Inhalte unseres Internetauftritts schnell ausliefern zu
                  können, greift der Dienst auf sog. JavaScript-Bibliotheken
                  zurück. Dabei werden entsprechende Dateien von dem CDN-Server
                  geladen, soweit sie nicht schon durch einen Besuch eines
                  anderen Internetauftritts in Ihrem Browser-Cache vorhanden
                  sind. Im Falle der Verbindung zu dem CDN-Server wird Ihre
                  IP-Adresse erfasst. Dabei kann nicht ausgeschlossen werden,
                  dass eine Verbindung zu einem Server außerhalb der EU erfolgt.
                </p>
                <p>
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser
                  berechtigtes Interesse liegt in der Beschleunigung der
                  Ladezeiten unseres Internetauftritts sowie in dessen
                  Optimierung.
                </p>
                <p>
                  Um die Ausführung des Java-Script-Codes von jQuery insgesamt
                  zu verhindern, können Sie einen sog. Java-Script-Blocker
                  installieren, wie bspw. noscript.net oder ghostery.com.
                  Sollten Sie die Ausführung des Java-Script-Codes verhindern
                  oder einschränken, kann dies aus technischen Gründen
                  allerdings dazu führen, dass womöglich nicht sämtliche Inhalte
                  und Funktionen unseres Internetauftritts verfügbar sind.
                </p>
                <p>
                  <a
                    href="https://pohl-waldemar.info"
                    target="_blank"
                    rel="noopener"
                  >
                    Muster-Datenschutzerklärung
                  </a>{" "}
                 
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Datenschutz;
